import { render, staticRenderFns } from "./ProductCreate.vue?vue&type=template&id=58410c2c&scoped=true&"
import script from "./ProductCreate.vue?vue&type=script&lang=js&"
export * from "./ProductCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreate.vue?vue&type=style&index=0&id=58410c2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58410c2c",
  null
  
)

export default component.exports